// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gcACc","newExpiryDate":"styles_newExpiryDate__gID2Y","footer":"styles_footer__19lTn"};